import React from 'react';
import StatsPageContainer from './stats.styles';
import StatsBox from './../../components/stats-box/stats-box.component';
const StatsPage = () => {
    return (
        <StatsPageContainer>
            <div className="container">
                <StatsBox
                    iconName="fas fa-mug-hot"
                    number="1.236"
                    text="Coffee Drinks"
                />
                <StatsBox
                    iconName="far fa-folder"
                    number="256"
                    text="Completed Projects"
                />
                <StatsBox
                    iconName="far fa-envelope"
                    number="1,743"
                    text="Mail Sent"
                />
                <StatsBox
                    iconName="fas fa-trophy"
                    number="17"
                    text="Awards Received"
                />
            </div>
        </StatsPageContainer>
    );
};

export default StatsPage;
